import logoUrl from '#app/assets/favicons/favicon.svg'

export function BrandPanel({
	tagline = 'Muziekles met directe feedback, XP en beats.',
}: {
	tagline?: string
}) {
	return (
		<div className="grid-bg relative h-full w-full">
			<div
				aria-hidden
				className="absolute inset-0"
				style={{
					background:
						'radial-gradient(circle at 30% 20%, rgba(236,72,153,0.20), transparent 55%), radial-gradient(circle at 75% 75%, rgba(6,182,212,0.18), transparent 55%), radial-gradient(circle at 85% 20%, rgba(139,92,246,0.16), transparent 60%)',
				}}
			/>

			<div className="relative flex h-full flex-col items-center justify-center px-12 text-center">
				<div className="flex items-center gap-3">
					<img src={logoUrl} alt="" className="h-10 w-10" />
					<span className="font-display text-[11px] text-neon-pink">
						MUZIEKDOCENT
					</span>
				</div>

				<h2 className="mt-8 max-w-md text-balance text-2xl font-semibold leading-snug text-white">
					{tagline}
				</h2>

				<div className="mt-10 flex items-center gap-2">
					<span className="size-2 rounded-full bg-neon-pink shadow-neon-pink" />
					<span className="size-2 rounded-full bg-neon-orange shadow-neon-orange" />
					<span className="size-2 rounded-full bg-neon-yellow shadow-neon-yellow" />
					<span className="size-2 rounded-full bg-neon-teal shadow-neon-teal" />
					<span className="size-2 rounded-full bg-neon-blue shadow-neon-blue" />
					<span className="size-2 rounded-full bg-neon-green shadow-neon-green" />
				</div>
			</div>
		</div>
	)
}
